import React, { useState, useEffect, useRef } from "react";
import Button from '../../button/button_v2';
import { Container } from "react-grid-system";
import Input from "../../input/input_v2";
import { FormContainer } from "./styles";
import { store } from "react-notifications-component";
import api from '../../../services/api';
import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
import ModalAlert from '../../modal/modalGeneric';
import validadorCpfCnpj from "../../../services/validadorCpfCnpj";
import ModalPassword from '../../modal/modal_password';
import ModalText from '../../modal/modalText';
import InputSign from "../../inputSign";
import { IconUploads } from '../../../assets/icons/iconUploads';
import mais from "../../../assets/Mais.png";
import { logout } from "../../../services/auth";
import { USER } from "./index";

import * as S from './styles'
import { Auxiliar, BodyG } from "../../../styles/stylesTypography";
import { theme } from "../../../styles/theme";
import CardRadio from "../../cardRadio";


const Agronomov2 = ({ ...props }) => {
    const { next, update, nome, cpf, isModal, email, enviar_receita, whatsapp: whatsappProp, agronomoId, onSave, assinatura: assinaturaProp, assinaturaEletronica: assinaturaEletronicaProp, onChangeAssinatura, emitiuReceita } = props;

    const [didInit, setDidInit] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [nomeId, setNomeId] = useState(nome);
    const [cpfId, setCpfId] = useState(cpf);
    const [emailAgronomo, setEmail] = useState(email);
    const [sendEmail, setSendEmail] = useState(false);
    const [sendWhatsapp, setSendWhatsapp] = useState(false);

    // A validação real (via microserviço, com fallback local) roda de forma
    // assíncrona no useEffect abaixo assim que cpfId é definido.
    const [cpfValido, setCpfValido] = useState(false);
    const cpfCheckRef = useRef(0);

    const [erroCpf, setErroCpf] = useState(false);
    const [erroCpfMsg, setErroCpfMsg] = useState(false);

    const [erroNome, setErroNome] = useState(false);
    const [erroNomeMsg, setErroNomeMsg] = useState('Informe o nome do responsável');

    const [erroEmail, setErroEmail] = useState(false);
    const [erroEmailMsg, setErroEmailMsg] = useState('');

    const [showModalBlock, setShowModalBlock] = useState(false);

    const [disabledNext, setDisabledNext] = useState(false);

    const [whatsapp, setWhatsapp] = useState(whatsappProp || '');
    const [erroWhatsapp, setErroWhatsapp] = useState(false);
    const [erroWhatsappMessage, setErroWhatsappMessage] = useState('Informe um número válido');
    const [saving, setSaving] = useState(false);
    const [assinatura, setAssinatura] = useState(assinaturaProp || 'M');

    const [file, setFile] = useState([]);
    const [namesfiles, setNamesfiles] = useState([]);
    const [textFile, setTextFile] = useState('');
    const [isValidate, setIsValidate] = useState(false);
    const [idCertificado, setIdCertificado] = useState('');
    const [password, setPassword] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalText, setShowModalText] = useState(false);
    const [renderInput, setRenderInput] = useState(true);
    const [estadosDigital, setEstadosDigital] = useState([]);
    const [excecoesEletronica, setExcecoesEletronica] = useState([]);
    const [sign, setSign] = useState(() => {
        if (assinaturaEletronicaProp && typeof assinaturaEletronicaProp === 'string' && assinaturaEletronicaProp.startsWith('data:image')) {
            return assinaturaEletronicaProp;
        }
        return '';
    });

    useEffect(() => {
        if (nome !== undefined) setNomeId(nome || '');
        if (cpf !== undefined) setCpfId(cpf || '');
        if (email !== undefined) setEmail(email || '');
        if (whatsappProp !== undefined) setWhatsapp(whatsappProp || '');
        if (typeof enviar_receita === 'number') setSendEmail(enviar_receita);
        if (typeof enviar_receita === 'boolean') setSendEmail(enviar_receita ? 1 : 0);
    }, [nome, cpf, email, whatsappProp, enviar_receita]);

    useEffect(() => {
        if (assinaturaProp !== undefined && assinaturaProp !== null && assinaturaProp !== '') {
            setAssinatura(assinaturaProp);
        }
    }, [assinaturaProp]);

    useEffect(() => {
        if (assinaturaEletronicaProp && typeof assinaturaEletronicaProp === 'string' && assinaturaEletronicaProp.startsWith('data:image')) {
            setSign(assinaturaEletronicaProp);
        }
    }, [assinaturaEletronicaProp]);

    useEffect(() => {
        const loadSignTypes = async () => {
            try {
                const response = await api.get('/agronomos/crea/assinaturas');
                const data = response?.data?.data;
                if (data) {
                    setEstadosDigital(data.digital || []);
                    setExcecoesEletronica(data.excecao_eletronica || []);
                }
            } catch (error) {}
        };
        loadSignTypes();
    }, []);

    useEffect(() => {
        const loadCertificate = async () => {
            if (!agronomoId || !cpfId) return;
            try {
                const payload = { cpf: cpfId };
                const responseCertificado = await api.post('/sign/consulta/', payload);
                const certificado = responseCertificado?.data?.data;
                if (certificado) {
                    if (certificado.arquivo) {
                        setNamesfiles([certificado.arquivo]);
                    }
                    if (certificado.id) {
                        setIdCertificado(certificado.id);
                    }
                }
            } catch (error) {
            }
        };

        loadCertificate();
    }, [agronomoId, cpfId]);


    const validateNome = nomeId => {
        setNomeId(nomeId);
        setErroNome(false);
    };

    const validateEmail = emailId => {
        setEmail(emailId);

        const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]+(\.[a-zA-Z]+)*$/;
        const isValidEmail = emailRegex.test(emailId);

        setErroEmail(!isValidEmail);
        setErroEmailMsg(!isValidEmail ? "Informe um e-mail!" : "");

        return isValidEmail;
    };

    const validateCpf = async (cpfId) => {
        setCpfId(cpfId);

        if (cpfId) {

            if (cpfId.length === 14) {
                const checkId = ++cpfCheckRef.current;
                const resultado = await validadorCpfCnpj(cpfId);
                if (checkId !== cpfCheckRef.current) return; // usuário já digitou algo novo, descarta resposta desatualizada

                setCpfValido(resultado.valido);

                if (!resultado.valido) {
                    setErroCpf(true);
                    setErroCpfMsg(resultado.erro || 'Informe um CPF válido!');
                } else {
                    setErroCpf(false);

                }
            } else {
                setCpfValido(false);
                setErroCpf(false);
            }
        } else {
            setCpfValido(false);
            setErroCpf(false);
        }

    };

    const validateWhatsapp = (numero) => {
        if(!numero) {
            setErroWhatsapp(false);
            setErroWhatsappMessage('');
            return true;
        }

        const telefoneNumeros = numero.replace(/\D/g, '');
    
        const isValidTelefone = telefoneNumeros.length === 10 || telefoneNumeros.length === 11;
    
        setErroWhatsapp(!isValidTelefone);
        setErroWhatsappMessage(!isValidTelefone ? 'Informe um número válido' : '');
    
        return isValidTelefone;
    };
    
    const changeWhatsapp = (value) => {
        setWhatsapp(value);
        setErroWhatsapp(false);
        setErroWhatsappMessage('');
    
        validateWhatsapp(value);
    };

    const handleAssinaturaChange = (tipo) => {
        setAssinatura(tipo);
        if (typeof onChangeAssinatura === 'function') {
            onChangeAssinatura(tipo);
        }
    };

    const validaFields = e => {
        if (nomeId) {
            if (cpfValido === false) {
                setErroCpf(true);
                setErroCpfMsg('CPF inválido');
                store.addNotification({
                    title: "Erro!",
                    message: "CPF inválido",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            } else {
                setErroCpf(false);
            }
        } else {
            if (cpfValido === false) {
                setErroCpf(true);
                setErroCpfMsg('CPF inválido');
                store.addNotification({
                    title: "Erro!",
                    message: "CPF inválido",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            } else {
                setErroCpf(false);
            }
        }
    };

    const validaCertificado = async (certificadoFile, certificadoPassword) => {
        if (cpfId) {
            if (certificadoFile && !isValidate && certificadoPassword) {
                const payload = {
                    certificado: certificadoFile,
                    cpf: cpfId,
                    senha: certificadoPassword,
                };
                try {
                    let user = JSON.parse(localStorage.getItem(USER));
                    if (user?.contrato?.agro_plan_functions) {
                        let isBlock = false;

                        user.contrato.agro_plan_functions.map((e) => {
                            if (e.agro_plans_function.id === 9) {
                                if (e.status === 0) {
                                    isBlock = true;
                                }
                            }
                        });

                        if (isBlock === true) {
                            closeModalPassword();
                            store.addNotification({
                                title: "Erro!",
                                message: `A função de assinatura digital não está liberada para seu plano!`,
                                type: "danger",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            });
                        } else {
                            const response = await api.post(`/sign/digital`, payload);
                            if (response) {
                                setIsValidate(true);
                            }
                            const input = document.getElementById('cpfId');
                            if (input) {
                                input.classList.remove("error");
                            }
                            store.addNotification({
                                title: "Sucesso!",
                                message: `${response.data.data.msg}`,
                                type: "success",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            });
                        }
                    } else {
                        logout();
                        window.location = '/login';
                    }
                } catch (error) {
                    closeModalPassword();
                    store.addNotification({
                        title: "Erro!",
                        message: identifyErrorMenssage(error, "ERRO-570 Erro ao validar o certificado digital - Tente novamente, se o erro persistir acione o suporte."),
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                }
            }
        } else {
            const input = document.getElementById('cpfId');
            if (input) {
                input.classList.add("error");
            }

            store.addNotification({
                title: "Erro!",
                message: `Informe o CPF!`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    const onChangeCertificate = (e) => {
        let user = JSON.parse(localStorage.getItem(USER));

        if (user?.contract_software_id === 6) {
            setShowModalBlock(true);
        } else {
            let cont = e.target.files.length;
            cont = cont - 1;

            if (e.target.files) {
                if (
                    e.target.files[cont].type === "application/x-pkcs12"
                ) {
                    let fil = e.target.files;
                    let reader = new FileReader();
                    reader.readAsDataURL(fil[0]);

                    reader.onload = (event) => {
                        setFile(event.target.result);
                        setTextFile(event.target.result);

                        if (cpfId) {
                            setShowModal(true);
                        } else {
                            const input = document.getElementById('cpfId');
                            if (input) {
                                input.classList.add("error");
                            }
                            store.addNotification({
                                title: "Erro!",
                                message: `Informe o CPF!`,
                                type: "danger",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            });
                        }
                    };
                    setNamesfiles(e.target.files[cont].name);

                } else {
                    store.addNotification({
                        title: "Erro!",
                        message: `O arquivo selecionado não possui a extensão correta`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                }
            } else {
                store.addNotification({
                    title: "Erro!",
                    message: `Não é possível enviar mais que um arquivo!`,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        }
    };

    const deleteCertificate = async () => {
        try {
            if (idCertificado) {
                const response = await api.delete(`/sign/delete/${idCertificado}`);
                setIdCertificado('');
                store.addNotification({
                    title: "Sucesso!",
                    message: `${response.data.data}`,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error, "ERRO-571 Erro ao remover o certificado digital - Tente novamente, se o erro persistir acione o suporte."),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    const deleteFile = async () => {
        await deleteCertificate();
        setNamesfiles([]);
        setIsValidate(false);
        setFile([]);
        setTextFile('');
    };

    const closeModalPassword = () => {
        setRenderInput(false);
        setShowModal(false);
        setPassword('');
        setNamesfiles([]);
        setTextFile('');
        setIsValidate(false);
    };

    const updatePassword = (value) => {
        setPassword(value);
        validaCertificado(file, value);
        setShowModal(false);
    };

    const openModalText = () => {
        setShowModalText(true);
    };

    const saveSign = (value) => {
        setSign(value);
    };

    const nextStep = async e => {
        const isTelephoneValid = validateWhatsapp(whatsapp);

        if (!nomeId || !emailAgronomo || !cpfId || !isTelephoneValid) {
            store.addNotification({
                title: "Erro!",
                message: `Verifique os campos em vermelho`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }

        if (!nomeId) {
            setErroNome(true);
        }

        const isEmailValid = validateEmail(emailAgronomo);

        if (!isEmailValid) {
            setErroEmail(true);
            setErroEmailMsg("Informe um e-mail!");
            store.addNotification({
                title: "Erro!",
                message: "E-mail inválido",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
        if (!cpfId) {
            setErroCpf(true);
            setErroCpfMsg("Informe um CPF");
        }
        if (cpfValido == false) {
            store.addNotification({
                title: "Erro!",
                message: `CPF inválido`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } 
              
        if (!isTelephoneValid) {
            setErroWhatsapp(true);
            store.addNotification({
                title: "Erro!",
                message: "Número inválido",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
        else {
            if (nomeId && isEmailValid && cpfId && isTelephoneValid) {
                setErroNome(false);
                setErroEmail(false);
                setErroCpf(false);
                setErroWhatsapp(false);

                const assinaturaToSend = sign;

                if (agronomoId && typeof onSave === 'function') {
                    try {
                        setSaving(true);
                        const ok = await onSave({
                            nome: nomeId,
                            email: emailAgronomo,
                            cpf: cpfId,
                            assinatura: assinaturaToSend,
                            enviar_receita: sendEmail ? 1 : 0,
                            whatsapp: whatsapp || "",
                        });
                        if (!ok) return;
                    } finally {
                        setSaving(false);
                    }
                }

                update(
                    nomeId, 
                    cpfId, 
                    emailAgronomo, 
                    sendEmail, 
                    whatsapp, 
                    sendWhatsapp
                );
                next();
            }
        }
    };

    useEffect(() => {
        setNomeId(nome || '');
    }, [nome]);

    useEffect(() => {
        setCpfId(cpf || '');
    }, [cpf]);

    useEffect(() => {
        if (!cpfId) {
            setCpfValido(false);
            return;
        }

        if (cpfId.length === 11 || cpfId.length > 11) {
            const checkId = ++cpfCheckRef.current;
            validadorCpfCnpj(cpfId).then((resultado) => {
                if (checkId !== cpfCheckRef.current) return; // resposta desatualizada

                setCpfValido(resultado.valido);
                if (resultado.valido) {
                    setErroCpf(false);
                    setErroCpfMsg('');
                }
            });
            return;
        }

        setCpfValido(false);
    }, [cpfId]);

    useEffect(() => {
        setEmail(email || '');
    }, [email]);

    useEffect(() => {
        setSendEmail(enviar_receita);
    }, [enviar_receita]);

    useEffect(() => {
        setWhatsapp(whatsappProp || '');
    }, [whatsappProp]);

    useEffect(() => {
        const checkForm = () => {
            const checkNome = nomeId ? true : false;
            
            const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]+(\.[a-zA-Z]+)*$/;
            const checkEmail = emailRegex.test(emailAgronomo);

            const checkCpf = cpfValido;

            const telefoneNumeros = whatsapp ? whatsapp.replace(/\D/g, '') : '';
            const checkWhatsapp = !whatsapp || telefoneNumeros.length === 10 || telefoneNumeros.length === 11;

            if(checkNome && checkEmail && checkCpf && checkWhatsapp){
                setDisabledNext(false);
            }else{
                setDisabledNext(true);
            }
        }

        checkForm();
    }, [nomeId, emailAgronomo, cpfValido, whatsapp]);

    return (
        <>
            <FormContainer isModal={props.isModal}>
                <Container style={{ width: '100%', paddingLeft: props.isModal ? '15px' : '15px', paddingRight: props.isModal ? '15px' : '15px' }}>
                    <form>
                        <Input
                            marginBottom="8px"
                            name="nome"
                            type="text"
                            label="Nome completo"
                            labelWithAsterisk={true}
                            id="nomeId"
                            onChange={e => validateNome(e)}
                            erro={erroNome}
                            messageErro={erroNomeMsg}
                            value={nomeId}
                            disabled={!!emitiuReceita}
                        />

                        <Input
                            marginBottom="8px"
                            label="E-mail"
                            labelWithAsterisk={true}
                            name="email"
                            className="input"
                            id="email"
                            onChange={e => validateEmail(e)}
                            yesNo={true}
                            messageYesNo={'RECEBER RECEITAS'}
                            whiteSpace={true}
                            erro={erroEmail}
                            // yesNoSpanWidth={'80px'}
                            messageErro={erroEmailMsg}
                            value={emailAgronomo}
                            initialYesNoValue={sendEmail === 1}
                            onChangeYesNo={(e) => setSendEmail(e ? 1 : 0)}
                        />

                        <Input
                            marginBottom="8px"
                            name="cpf"
                            type="text"
                            label="CPF"
                            labelWithAsterisk={true}
                            id="cpfId"
                            value={cpfId}
                            onChange={e => validateCpf(e)}
                            onBlur={(e) => validaFields(e.target.value)}
                            maxlength={14}
                            erro={erroCpf}
                            messageErro={erroCpfMsg}
                            inputmode="numeric"
                            disabled={!!emitiuReceita}
                        />

                        <Input
                            marginBottom="8px"
                            id="telefone"
                            label="Whatsapp"
                            name="telefonecelular"
                            value={whatsapp}
                            onChange={e => changeWhatsapp(e)}
                            erro={erroWhatsapp}
                            messageErro={erroWhatsappMessage}
                            yesNo={false}
                            messageYesNo={'RECEBER ALERTAS'}
                            whiteSpace={true}
                            inputmode="numeric"
                            onChangeYesNo={(e) => setSendWhatsapp(e ? 1 : 0)}
                        />

                        {/* {props.hideAssinaturaSelector && (
                            <S.ContainerMethod>
                                <CardRadio
                                    selected={assinatura === "M"}
                                    onClick={() => handleAssinaturaChange("M")}
                                    id="assinatura-m"
                                    name="card_radio_assinatura"
                                    checked={assinatura === "M"}
                                    onChange={() => handleAssinaturaChange("M")}
                                >
                                    <S.CardPlansHeader>
                                        <BodyG fontWeight={800} color={theme.colors.gray.Cinza_2}>
                                            Assinatura <br /> Manual
                                        </BodyG>

                                        <Auxiliar color={theme.colors.gray.Cinza_5}>
                                            Necessário imprimir o Receituário para{" "}
                                            <b>assinar à próprio punho.</b> Aceita em todos os
                                            estados brasileiros.
                                        </Auxiliar>
                                    </S.CardPlansHeader>
                                </CardRadio>

                                <CardRadio
                                    selected={assinatura === "E"}
                                    onClick={() => handleAssinaturaChange("E")}
                                    id="assinatura-e"
                                    name="card_radio_assinatura"
                                    checked={assinatura === "E"}
                                    onChange={() => handleAssinaturaChange("E")}
                                >
                                    <S.CardPlansHeader>
                                        <BodyG fontWeight={800} color={theme.colors.gray.Cinza_2}>
                                            Assinatura <br /> Eletrônica
                                        </BodyG>

                                        <Auxiliar color={theme.colors.gray.Cinza_5}>
                                            Conjunto de <b>dados digitais para validação.</b> Aceita
                                            em todos os estados brasileiros, exceto MT, PR, SC e RS.
                                        </Auxiliar>
                                    </S.CardPlansHeader>
                                </CardRadio>

                                <CardRadio
                                    selected={assinatura === "D"}
                                    onClick={() => handleAssinaturaChange("D")}
                                    id="assinatura-d"
                                    name="card_radio_assinatura"
                                    checked={assinatura === "D"}
                                    onChange={() => handleAssinaturaChange("D")}
                                >
                                    <S.CardPlansHeader>
                                        <BodyG fontWeight={800} color={theme.colors.gray.Cinza_2}>
                                            Assinatura <br /> Digital
                                        </BodyG>

                                        <Auxiliar color={theme.colors.gray.Cinza_5}>
                                            Necessário fazer upload de <b>certificado A1</b> válido.
                                            Aceita nos estados MT, PR, SC, RS, GO, MG, ES, SP e MS.
                                        </Auxiliar>
                                    </S.CardPlansHeader>
                                </CardRadio>
                            </S.ContainerMethod>
                        )}
                        
                        {assinatura === 'D' ? (
                            <>
                                <div style={{
                                    width: '100%',
                                    marginTop: "20px"
                                }}>
                                    <label style={{
                                        paddingLeft: '15px',
                                        textAlign: 'left',
                                        fontSize: '12px',
                                        fontWeight: 700,
                                        color: '#8a92a2',
                                    }}>Upload certificado digital</label>
                                    <div className="arquivos">
                                        <label
                                            className='btn-update'
                                            htmlFor='input-file'
                                            multiple
                                            onClick={() => { setRenderInput(true); }}
                                        >
                                            <IconUploads width="auto" height="40px" marginBottom="100px" display="flex" alignItems="center" justifyContent="center" />
                                            Selecione o arquivo PFX em seu computador.<br></br><br></br>O upload do certificado é necessário caso deseje assinar sua receita digitalmente.
                                            <label className="arq-name">
                                                {namesfiles.length > 0 ?
                                                    (<>
                                                        {namesfiles}
                                                        <img src={mais} width="20" height="20" onClick={() => deleteFile()} />
                                                    </>) : "Nenhum arquivo selecionado"} </label>
                                        </label>
                                    </div>


                                    {renderInput ? (
                                        <input
                                            style={{ display: "none" }}
                                            type="file"
                                            id="input-file"
                                            name="file"
                                            multiple
                                            onChange={(e) => onChangeCertificate(e)}
                                        />
                                    ) : (null)}
                                </div>
                            </>
                        ) : assinatura === 'E' ? (
                            <div style={{ 
                                width: '100%',
                                marginTop: "32px"
                                }}>
                                <InputSign
                                    sign={sign}
                                    update={(e) => saveSign(e)}
                                />
                            </div>
                        ) : assinatura === 'M' ? (
                           null
                        ) : null} */}
                    </form>
                </Container>

                <div
                    style={{
                        width: '100%',
                        padding: '0 15px',
                        marginTop: '20px',
                    }}
                >
                    <Button
                        width='100%'
                        height='50px'
                        value='Salvar Técnico'
                        outline={false}
                        disabled={disabledNext || saving}
                        onClick={() => nextStep()}
                        loading={saving}
                    />
                </div>
            </FormContainer>

            {/* <ModalPassword
                text={"Precisamos da sua senha para validar a autenticidade do certificado. Para sua segurança, essa senha não ficará salva em nossos servidores."}
                show={showModal}
                update={(e) => updatePassword(e)}
                onHide={closeModalPassword}
            />
            <ModalText
                show={showModalText}
                onHide={() => setShowModalText(false)}
                text={"Certificado digital é um arquivo eletrônico que serve como identidade virtual para uma pessoa física ou jurídica. Ele serve para agilizar a assinatura conferindo legitimidade aos documentos digitais, que passam a possuir validade jurídica. Esse certificado deve ser emitido por uma Autoridade Certificadora vinculada ao ICP-Brasil"}
                btnOk={false}
            />

            <ModalAlert
                show={showModalBlock}
                onHide={false}
            >
                <h4 style={{
                    textAlign: 'center'
                }}>Essa é uma função exclusiva para clientes AgroReceita</h4>

                <p style={{
                    textAlign: 'center',
                    marginTop: '20px',
                }}>
                    Para não comprometer o controle de suas receitas agronômicas essa função só pode ser utilizada nos planos Light e Pro. Entre em contato com nosso suporte e faça o upgrade do seu plano para desbloquear esse recurso.
                </p>

                <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px' }}>
                    <Button
                        width='296px'
                        height='50px'
                        value='ENTENDI'
                        outline={false}
                        disabled={false}
                        onClick={() => setShowModalBlock(false)}
                        loading={false}
                    />
                </div>
            </ModalAlert> */}

        </>
    );
};
export default Agronomov2;
